/* eslint-disable no-unused-expressions */
import { Button, Input } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const { Search } = Input;

const TabNavigation = ({
  step,
  setStep,
  service,
  onPerDevices,
  onNotificationEvent,
  onSearchDeviceByName,
}) => {
  const { t } = useTranslation();
  const configurationInput = service?.configurationInput;

  const parsedConfig = useMemo(() => {
    if (!configurationInput) return null;
    try {
      return JSON.parse(configurationInput);
    } catch {
      return null;
    }
  }, [configurationInput]);

  const hasPerDevice = useMemo(() => {
    const perDev = parsedConfig?.perDevice;
    if (Array.isArray(perDev)) {
      return perDev.length > 0;
    }
    return Boolean(perDev && Object.keys(perDev).length > 0);
  }, [parsedConfig?.perDevice]);

  const hasPerNamespace = useMemo(() => {
    const perNs = parsedConfig?.perNamespace;
    if (Array.isArray(perNs)) {
      return perNs.length > 0;
    }
    return Boolean(perNs && Object.keys(perNs).length > 0);
  }, [parsedConfig?.perNamespace]);

  const hasPerAccount = useMemo(() => {
    const perAcc = parsedConfig?.perAccount;
    if (Array.isArray(perAcc)) {
      return perAcc.length > 0;
    }
    return Boolean(perAcc && Object.keys(perAcc).length > 0);
  }, [parsedConfig?.perAccount]);

  const hasSettingTab =
    parsedConfig && (hasPerNamespace || hasPerAccount || hasPerDevice);

  return (
    <div className="button-tab">
      <div>
        <Button
          type={step === 0 ? 'primary' : 'default'}
          style={{ marginLeft: 'auto', width: '96px' }}
          onClick={() => setStep(0)}
        >
          {t('Overview')}
        </Button>
        <Button
          type={step === 1 ? 'primary' : 'default'}
          style={{ marginLeft: '8px', width: '96px' }}
          onClick={() => setStep(1)}
        >
          {t('Activation')}
        </Button>
        {hasSettingTab && (
          <Button
            type={step === 2 ? 'primary' : 'default'}
            style={{ marginLeft: '8px', width: '96px' }}
            onClick={() => {
              setStep(2);
              if (onPerDevices) {
                onPerDevices();
              }
              if (onNotificationEvent) {
                onNotificationEvent(service?.category);
              }
            }}
          >
            {t('Setting')}
          </Button>
        )}
        {service?.baseUrl && (
          <Button
            type={step === 3 ? 'primary' : 'default'}
            style={{ marginLeft: '8px', width: '96px' }}
            onClick={() => setStep(3)}
          >
            {t('Console')}
          </Button>
        )}
      </div>
      {step === 1 && (
        <Search
          placeholder={t('Search by name')}
          onSearch={onSearchDeviceByName}
          style={{ width: 280 }}
          allowClear
        />
      )}
    </div>
  );
};

export default TabNavigation;
